import React from 'react';
import { Controller } from 'react-hook-form';
import _get from 'lodash/get';
import Text from '../baseui/input/text';

interface ITextInput {
	name: any;
	inputType: any;
	control: any;
	defaultValue: any;
	onChangeCallback?: any;
}

const TextInput: React.FC<ITextInput> = (props) => {
	const { name, inputType, control, defaultValue, onChangeCallback } = props;

	return (
		<Controller
			render={({ field: { onChange, value } }) => {
				return <Text onChangeCallback={onChangeCallback} {...props} value={value} onChange={onChange} type={inputType} />;
			}}
			control={control}
			name={name}
			defaultValue={defaultValue && _get(defaultValue, ['field', ...defaultValue.path])}
		/>
	);
};

export default TextInput;
